import React from "react";

interface IPageHeaderProps {
  title: string;
  /** One line telling someone new what this page is for. */
  description?: string;
  /** Rendered on the right — page-level actions, counts or a date range. */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * The one page title in the app. Every page uses this so headings stop
 * drifting between h2, h4 and nothing at all.
 */
export const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  description,
  actions,
  className,
}) => (
  <div
    className={`d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3 ${
      className ?? ""
    }`}
  >
    <div>
      <h4 className="mb-0">{title}</h4>
      {description && (
        <div className="text-muted small mt-1">{description}</div>
      )}
    </div>
    {actions && (
      <div className="d-flex align-items-center flex-wrap gap-2">{actions}</div>
    )}
  </div>
);
